<style lang="less" scoped>
.value {
    padding: 5px;
    width: 100%;
    display: inline-block;
    text-align: center;
}
.select_p {
  cursor: pointer;
  margin: 15px 0;
}
.td_special {
  white-space:nowrap;
}
.print-container_in {
  width: 100%;
  table {
    width: 100%;
  }
}
.print-container{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    font-size: 14px;
    z-index: 10000;
    color: #000;
    background: white;
}
.screening-condition {
          display: none;
        }
    @media print {
        .screening-condition {
          display: block;
        }
        .value {
            white-space: nowrap;
            font-size: 1mm;
            width: 100%;
            display: inline-block;
            text-align: center;
        }
    }
</style>
<template>
  <div>
    <Spin
      v-if="getDataLoading"
      fix
    />
    <div style="margin:10px 0">
      <DatePicker
        v-model="params.month"
        type="month"
        placeholder="请选择日期"
        style="width: 200px"
        :clearable="false"
        @on-change="changeParams"
      />
      <Select
        v-model="params.company_code"
        placeholder="请选择公司"
        style="width: 250px;margin-left:10px"
        clearable
        @on-clear="changeParams"
        @on-change="changeParams"
      >
        <Option
          v-for="item in companies "
          :key="item.name"
          :value="item.company_code"
        >
          {{ item.name }}
        </Option>
      </Select>
      <span style="margin:0 10px 0 0">
        <Select
          v-model="params.in_type"
          style="width:150px;margin-left:10px"
          placeholder="请选择入库类型"
          clearable
          @on-clear="changeParams"
          @on-change="changeParams"
        >
          <Option
            v-for="item in type_list"
            :key="item.value"
            :value="item.value"
          >
            {{ item.title }}
          </Option>
        </Select>
      </span>
      <span style="margin:0 10px 0 0">
        <Select
          v-model="params.warehouse_id"
          style="width:300px;margin-right:10px"
          placeholder="请选择仓库"
          filterable
          clearable
          @on-clear="changeParams"
          @on-change="changeParams"
        >
          <Option
            v-for="item in warehouses_list"
            :key="item.id"
            :value="item.id"
          >
            {{ item.name }}
          </Option>
        </Select>
      </span>
      <Button
        style="margin-left:10px"
        type="primary"
        @click="printFun"
      >
        打印
      </Button>
      <Button
        style="margin-left:10px"
        type="primary"
        @click="outputExcel"
      >
        导出excel
      </Button>
    </div>
    <div
      ref="#print_list"
      class="contain-out"
      :class="{
        'print-container':showPrint
      }"
    >
      <div class="screening-condition">
        筛选条件：<span>时间：{{ print_detail.month }}</span>；
        <span>公司：{{ print_detail.company }}</span>；
        <span>入库类型：{{ print_detail.in_type_name }}</span>；
        <span>仓库：{{ print_detail.warehouse_name }}</span>；
      </div>
      <div
        class="print-container_in"
      >
        <table
          ref="#out-table"
          class="print_container_out"
          style="border-collapse:collapse;"
          border="1"
        >
          <thead>
            <tr>
              <th
                v-for="(item) in print_table_fields"
                :key="item.key"
                class="td_special"
              >
                <span class="value">
                  {{ item.title }}
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(child,index) in table_list"
              :key="index"
            >
              <td
                v-for="(item,itemIndex) in print_table_fields"
                :key="itemIndex"
                class="value_td"
              >
                <CustomRender
                  v-if="item.render"
                  :render="item.render"
                  :data="child"
                />
                <span
                  v-else
                  class="value"
                >
                  {{ toTargetStr(child[item.key]) }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script route="/stock/stock_in_print">
  import { print_table_fields, type_list } from './libs/fields'
  import CustomRender from './custom_render'
  import StockUtil from './libs/util';
  import moment from 'moment'
  import FileSaver from 'file-saver'
  import XLSX from 'xlsx'
  import {mapGetters} from "vuex";
  const LOCALSTORAGE_STOCK_STOCK_IN_PRINT = 'localstorage_stock_stock_in_print'
  export default {
    /* router_info_start */
    router_info:{
      path: '/stock/stock_in_print',
      noChkout: true
    },
    /* router_info_end */
    components: { CustomRender },
    data() {
      this.type_list = type_list
      this.print_table_fields = print_table_fields
      /* --------------- 通过localstorage 保存之前的打印条件 ---------------- */
      const localstorage_invoice_invoice_print = localStorage.getItem(LOCALSTORAGE_STOCK_STOCK_IN_PRINT)
      const params = {
        month: moment().format('YYYY-MM'),
        warehouse_id: '',
        company_code:'',
        in_type:''
      }
      if (localstorage_invoice_invoice_print) {
        const query = JSON.parse(localstorage_invoice_invoice_print)
        if (Object.prototype.toString.apply(query) !== "[object Object]") {
          return
        }
        Object.keys(params).forEach(key => {
          params[key] = query[key] || params[key]
        })
        localStorage.removeItem(LOCALSTORAGE_STOCK_STOCK_IN_PRINT)
      }
      return {
        showPrint:false,
        table_list:[],
        getDataLoading: false,
        params: {
          ...params
        }
      }
    },
    computed: {
      ...mapGetters({
        companies: 'async/companies',
      }),
      print_detail() { // 打印展示在表头的筛选条件
        const { mouth, company_code, warehouse_id, in_type } = this.params
        const companies_hash = (this.companies || []).reduce((total, item) => {
          total[item.id] = item.name
          return total
        }, {})
        const warehouses_list_hash = (this.warehouses_list || []).reduce((total, item) => {
          total[item.id] = item.name
          return total
        }, {})
        return {
          month: moment(mouth).format('YYYY-MM'),
          company:companies_hash[company_code] || '全部公司',
          in_type_name: StockUtil.getInTypeName(in_type) || '全部入库类型',
          warehouse_name: warehouses_list_hash[warehouse_id] || '全部仓库'
        }
      },
      warehouses_list() { // 仓库列表
        const { warehouses = {} } = this.$store.state || {}
        const arr = []
        Object.keys(warehouses).forEach(key => {
          arr.push(warehouses[key])
        })
        return arr
      },
    },
    mounted() {
      this.getTableData()
    },
    methods: {
      toTargetStr(target) { // html模板 渲染数据
        if (target === '' || target === undefined || target === null || (typeof target === 'string' && !target.trim())) {
          return '-'
        }
        return target + ''
      },
      getTableData() { // 请求数据
        const params = {
          ...this.params,
          month: moment(this.params.month).format('YYYY-MM'),
        }
        const clone = {...params}
        for (const key in clone) {
          params[key] = clone[key] || undefined

        }
        this.getDataLoading = true
        Util.ajax.get('/stock_in_record/credentials_list', { params }).then((response) => {
          return response.data;
        }).then(({ data, code, msg }) => {
          if (code !== 1) {
            this.table_list = []
            this.$Modal.error({
              title: '错误',
              content: msg
            });
            return
          }
          this.table_list = data.records
        }).catch(() => {
          this.$Modal.error({
            title: '错误',
            content: '网络错误'
          });
          this.table_list = []
        }).finally(() => {
          this.getDataLoading = false
        })
      },
      printFun() { // 打印
        window.document.body.innerHTML = this.$refs['#print_list'].innerHTML
        this.showPrint = true
        window.print()
        const { query = {}, path } = this.$router.currentRoute
        const { company_code, month, in_type, warehouse_id } = this.params
        const params = {
          ...query,
          rt: +new Date(),
        }
        /* ----------------------- 存入 localstorage 中，打印结束或者取消时返回当前页面并选中筛选条件 ------------------------- */
        const localstorage_invoice_invoice_print = {
          month: moment(month).format('YYYY-MM'),
          in_type,
          company_code,
          warehouse_id
        }
        localStorage.setItem(LOCALSTORAGE_STOCK_STOCK_IN_PRINT, JSON.stringify(localstorage_invoice_invoice_print))
        const query_str = Object.keys(params).reduce((total, key) => total + `${total ? '&' : ''}${key}=${params[key]}`, '')
        window.location.href = window.location.origin + path + '?' + query_str
      },
      changeParams() { // 筛选出发请求数据
        if (this.params.warehouse_id === 0) {
          this.params.warehouse_id = undefined
        }
        this.getTableData()
      },
      outputExcel() { // 导出excel
        const wb = XLSX.utils.table_to_book(this.$refs['#out-table'])
        const wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
        try {
          FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), `${this.print_detail.month}_${this.print_detail.company}_${this.print_detail.in_type_name}_${this.print_detail.warehouse_name}.xlsx`)
        } catch (e) { if (typeof console !== 'undefined') console.log(e, wbout) }
        return wbout
      }
    }
  }
</script>
